import React from 'react';
function BMITable({ classification }) {
    return (
        <table >
            <thead>
                <tr>
                    <th >Body Mass Index (BMI)</th>
                    <th >Nutritional Status</th>
                </tr>
            </thead>
            <tbody>
                <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
                    <td>Less than 18.5</td>
                    <td>Underweight</td>
                </tr>
                <tr className={classification === 'Normal weight' ? 'highlightedOk' : ''}>
                    <td>18.5–24.9</td>
                    <td>Normal weight</td>
                </tr>
                <tr className={classification === 'Pre-obesity' ? 'highlightedWarning' : ''}>
                    <td>25.0–29.9</td>
                    <td>Pre-obesity</td>
                </tr>
                <tr className={classification === 'Obesity class I' ? 'highlightedDanger' : ''}>
                    <td>30.0–34.9</td>
                    <td>Obesity class I</td>
                </tr>
                <tr className={classification === 'Obesity class II' ? 'highlightedDanger' : ''}>
                    <td>35.0–39.9</td>
                    <td>Obesity class II</td>
                </tr>
                <tr className={classification === 'Obesity class III' ? 'highlightedDanger' : ''}>
                    <td>40 or more</td>
                    <td>Obesity class III</td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Source:</b>{' '}
                        <a href="https://www.who.int/europe/news-room/fact-sheets/item/a-healthy-lifestyle---who-recommendations">
                            World Health Organization
                        </a>
                    </td>
                </tr>
                <tr>
                    <td colSpan="2">
                        <b>Last Reviewed Date:</b>28/02/2026
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
export default BMITable;
